import Separator from "@/v2-ui/separator"
import Table from "@/v2-backoffice-client/components/table"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import UserStatusUpdateManyMenu from "@/v2-backoffice-client/user/status/update/many/UserStatusUpdateManyMenu"
import UserContactSyncManyButton from "@/v2-backoffice-client/user/contact/sync/many/UserContactSyncManyButton"
import UserMigrateManyButton from "@/v2-backoffice-client/user/migration/many/UserMigrateManyButton"
import TenantUserAddManySelector from "@/v2-backoffice-client/tenant/user/add/many/TenantUserAddManySelector"
import UserCustomerUpdateManySelector from "@/v2-backoffice-client/user/customer/update/many/UserCustomerUpdateManySelector"

export type CustomerUserTableSelectionToolbarProps = {
  users: UserFragment[]
  reset?(): void
}

function CustomerUserTableSelectionToolbar(
  props: CustomerUserTableSelectionToolbarProps,
) {
  const { users, reset } = props

  return (
    <>
      <Table.ExportSelectionButton
        fileName="customer-users"
        selectionCount={users.length}
      />

      <TenantUserAddManySelector
        isStacked
        variant="ghost"
        users={users}
        onCompleted={reset}
        content="Add the selected users to a team."
      >
        Team
      </TenantUserAddManySelector>

      <UserCustomerUpdateManySelector
        isStacked
        variant="ghost"
        users={users}
        onCompleted={reset}
        content="Update the customer that owns the selected users: whose licenses and seats apply to them."
      >
        Customer
      </UserCustomerUpdateManySelector>

      <UserContactSyncManyButton users={users} onCompleted={reset} />

      {/* No pinning tenant here: a customer's users span its teams, so each
          user's single active membership decides (multi-team members get
          the per-user pointer to their team's dialog). */}
      <UserMigrateManyButton users={users} onCompleted={reset} />

      <Separator orientation="vertical" />
      <UserStatusUpdateManyMenu users={users} onCompleted={reset} />
    </>
  )
}

export default CustomerUserTableSelectionToolbar
